module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui middle aligned grid",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "margin": "0 auto"
    },
    attrs: {
      "id": "anonbg"
    }
  }, [_c('div', {
    staticClass: "mt4 column"
  }, [_vm._m(0), _vm._v(" "), _c('center', [_c('div', {
    staticClass: "row center"
  }, [_c('div', {
    staticClass: "fourteen wide column"
  }, [_c('div', {
    staticClass: "ui fluid card",
    staticStyle: {
      "padding": "24px",
      "font-size": "24px",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n              Thank you for continuing your subscription."), _c('br'), _vm._v("\n              We appreciate being able to service your account."), _c('br'), _vm._v(" "), (_vm.$root.newPricingMessage !== '') ? _c('div', [_vm._v("\n                This confirms that you " + _vm._s(_vm.$root.newPricingMessage)), _c('br'), _c('br')]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "ui right labeled icon large button setupStep",
    staticStyle: {
      "margin": "auto",
      "display": "block"
    },
    on: {
      "click": _vm.nextButtonPress
    }
  }, [_c('i', {
    staticClass: "right arrow icon"
  }), _vm._v("\n              link to account settings to view subscription\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid card",
    staticStyle: {
      "padding": "24px",
      "font-size": "24px",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n              Check out our most recent blogs if they can provide any help for your Amazon business!\n              "), _c('hr', {
    staticClass: "solid"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui fluid container",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "ui stackable doubling three cards"
  }, [_c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/streamline-product-issue-management-how-an-integrated-issue-tracker-simplifies-amazon-asin-management",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/3.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      Streamline Product Issue Management: How an Integrated Issue Tracker Simplifies Amazon ASIN Management\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      Amazon ASINs, or Amazon Standard Identification Numbers, are unique alphanumeric codes assigned to each product listed on the Amazon marketplace. Learn More Here!\n                    ")])])]), _vm._v(" "), _c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/elevate-your-inventory-management-game-a-glance-at-your-total-and-sellable-stock",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/1.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      Elevate Your Inventory Management Game: A Glance at Your Total and Sellable Stock\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      Inventory management is the backbone of a successful e-commerce business, and keeping a close eye on your stock levels is crucial.\n                    ")])])]), _vm._v(" "), _c('a', {
    staticClass: "ui card tall segment",
    attrs: {
      "href": "https://sentrykit.com/blog/the-ultimate-guide-to-mastering-amazon-ppc-advertising-boost-your-sales-with-effective-search-engine-marketing-strategies",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "three wide column"
  }, [_c('div', {
    staticClass: "ui image",
    staticStyle: {
      "padding": "2%"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/2.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "border-top": "none"
    }
  }, [_vm._v("\n                      The Ultimate Guide to Mastering Amazon PPC Advertising: Boost Your Sales with Effective Search Engine Marketing Strategies\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    staticStyle: {
      "font-size": "16px",
      "padding": "5px",
      "color": "grey"
    }
  }, [_vm._v("\n                      In this ultimate guide, we will delve into the world of Amazon PPC advertising and equip you with the knowledge and techniques needed to master this powerful marketing tool.\n                    ")])])])])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui center"
  }, [_c('img', {
    staticStyle: {
      "width": "350px",
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "src": require("./assets/skwhite_noslogan.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62984c0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/NewPricingRedeemedPage.vue
// module id = 784
// module chunks = 2